import { useState } from 'react'

export interface AnnouncementConfig {
  storageKey: string
  autoShow?: boolean
}

export const useAnnouncement = (config: AnnouncementConfig) => {
  const [dialogOpen, setDialogOpen] = useState(
    config.autoShow !== false ? localStorage.getItem(config.storageKey) !== '1' : false
  )

  const dismiss = () => {
    localStorage.setItem(config.storageKey, '1')
    setDialogOpen(false)
  }

  const open = () => {
    setDialogOpen(true)
  }

  return {
    dialogOpen,
    setDialogOpen,
    dismiss,
    open,
  }
}
